const visileColumns = [

    {
        title: "Document ID",
        field: "id",
        locked: false,
        filter: "numeric",
        width: 160,
        show: true,
        customFilterType: "CustomNumericText",
        className: "text-end",
        headerClassName: "number-align",
    },
    // {
    //   title: "Subscriber Id",
    //   field: "SubscriberID",
    //   locked: false,
    //   filter: "text",
    //   width: 200,
    //   show: true,
    // },
    {
        title: "Content Type",
        field: "contentType",
        locked: false,
        filter: "text",
        width: 200,
        show: true,
    },
    {
        title: "Is Required",
        field: "isRequired",
        locked: false,
        filter: "boolean",
        width: 160,
        show: true,
    },
    {
        title: "Remarks",
        field: "remarks",
        locked: false,
        filter: "text",
        width: 300,
        show: true,
    }


];

export default visileColumns;
